import styled from 'styled-components'

export const LogoWrapper = styled.div`
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid ${o => o.theme.color.deprecated.stone};
  max-width: 200px;
  width: 100%;
`
